//import domtoimage from 'dom-to-image';
import uxTour from 'uxTour';
const DRAGGIN_SIZE = 40;

class PyramidBuilderController {

  constructor(pyramidBuilderService, $cookies, $scope, treeDiagramRendererFactory, treeDiagramFactory, $timeout, $compile) {
    'ngInject';

    Object.assign(this, { pyramidBuilderService, $cookies, $scope, treeDiagramRendererFactory, treeDiagramFactory, $timeout, $compile });

    this.showSlider = true;
    this.store = this.pyramidBuilderService.store;
    this.scale = {
      value: 0.9,
      options: {
        floor: 0.2,
        ceil: 2,
        step: 0.01,
        precision: 2,
        onChange: () => this.renderer.tree.zoomTo(this.scale.value)
      }
    };
    this.opacity = {
      value: 0.9,
      options: {
        floor: 0.2,
        ceil: 1,
        step: 0.05,
        precision: 2
      }
    };

    this.activePyramid = {};
  }

  $onDestroy() {
    if (this.pyramidData) this.pyramidBuilderService.deletePyramid(this.key);
  }

  init() {
    let scale = 0.9;
    let opacity = 0.9;

    const pyramidSettings = this.$cookies.getObject('pyramidSettings');
    if (pyramidSettings) {
      scale = pyramidSettings.scale || scale;
      opacity = pyramidSettings.opacity || opacity;
    }

    if (this.pyramidData) {
      this.pyramidBuilderService.inited = true;

      if (this.pyramidData.scale && this.pyramidData.scale.k) {
        this.scale.value = this.pyramidData.scale.k;
        scale = this.pyramidData.scale;
      } else {
        this.scale.value = this.pyramidData.scale;
        scale = this.pyramidData.scale || scale;
      }
    }

    this.pyramidBuilderService.init(this.sectionTitle, scale)
      .then(data => {
        this.key = data.key;
        this.activePyramid = data;
        this.opacity.value = this.pyramidBuilderService.store.opacity || opacity;
        if (this.pyramidData) {
          this.activePyramid.pyramid.question.active = false;
          this.activePyramid.pyramid.scheme = this.pyramidData.scheme;
          this.opacity.value = this.pyramidData.opacity || opacity;
          this.activePyramid.additionalBox = this.pyramidData.additionalBox;
          if (this.pyramidData.scq) {
            this.activePyramid.scq = this.pyramidData.scq;
            this.activePyramid.scq.active = true;
          }
        }

        this.active = this.activePyramid.guid;
      })
      .then(() => {
        $('.pyramid__options').draggable();
        this.$timeout(() => {
          // this.updateSlider();
          this.createTreeDiagram();
        });

        if (this.pyramidData) {
          this.pyramidBuilderService.inited = false;
          if (this.pyramidData.tourData) {
            this.optionsOpen = true;
            const tour = new uxTour();
            this.$timeout(() => tour.start(this.pyramidData.tourData));
          }
        }
        this.inited = true;
      });
  }

  // updateSlider() {
  //   $($('.rz-pointer-min')[0]).css('left', (380 / 180) * this.scale.value * 100 - 27);
  //   $($('.rz-pointer-min')[1]).css('left', 315);
  // }

  getScaleValue() {
    return `Scale ${Math.floor(this.scale.value * 100)}% `;
  }

  getOpacity() {
    return `Opacity ${Math.floor(this.opacity.value * 100)}%`
  }

  updateOpacity(increase) {
    if (!increase) {
      this.opacity -= 0.05;
    } else if (this.opacity !== 1) {
      this.opacity += 0.05;
    }
  }

  toggle() {
    this.open = !this.open;

    if (!this.isActiveDemo) {
      if (this.open) {
        $('body').addClass('pyramid__builder--open');
      } else {
        $('body').removeClass('pyramid__builder--open');
      }
    }


    if (this.inited && this.isActiveDemo) {
      this.activePyramid.scq.active = true;
    }

    if (!this.open) {
      this.$cookies.putObject('pyramidSettings', { opacity: this.opacity.value, scale: this.scale.value });

      if (this.isActiveDemo) {
        this.onClosePyramidBuilder({
          $event: {
            store: this.pyramidBuilderService.store,
            guid: this.active,
            key: this.key
          }
        });
      }

      this.pyramidBuilderService.deletePyramid(this.key);
      this.isActiveDemo = false;
    } else {
      this.init();
    }
  }

  toggleVisible(prop) {
    prop.active = !prop.active;
  }

  generatePDF() {
    const doc = new jsPDF();
    const pyramid = $('.content-item.active .pyramid__builder-body');
    pyramid.css('background', '#0868ac');

    function filter(node) {
      return (node.tagName !== 'i');
    }

    //domtoimage.toPng(node)
    //  .then(function (dataUrl) {
    //    var img = new Image();
    //    img.src = dataUrl;
    //    document.body.appendChild(img);
    //  })
    //  .catch(function (error) {
    //    console.error('oops, something went wrong!', error);
    //  });

    // domtoimage.toSvg(pyramid[0], { filter: filter })
    //   .then(function (dataUrl) {
    //     doc.addImage(dataUrl, 'JPEG', 0, 0);
    //     doc.save(`${this.activePyramid.title}.pdf`);
    //   });

    // html2canvas(pyramid[0], { width: 1200, height: 920 }).then(canvas => {
    //   var data = canvas.toDataURL();
    //   // console.log(data);
    //   window.open(canvas.toDataURL("image/png"));
    //   // doc.addImage(data, 'JPEG', 0, 0);
    //   // doc.save(`${this.activePyramid.title}.pdf`);
    // });
  }

  createTreeDiagram() {
    this.renderer = this.treeDiagramRendererFactory.getInstance(this.activePyramid.pyramid.question.active, this.activePyramid.pyramid.zoom, this.activePyramid.pyramid.scheme, !this.isActiveDemo);

    this.treeDiagram = this.treeDiagramFactory.getInstance(this.exercise, this.renderer);

    this.renderer.questionFlag = this.activePyramid.pyramid.question.active;

    this.active = this.activePyramid.guid;

    // on mouse wheel event
    this.renderer.onZoom = (scale) => {
      this.scale.value = Math.ceil(scale.k * 100) / 100;
      this.$scope.$broadcast('rzSliderForceRender');
      this.$scope.$broadcast('reCalcViewDimensions');
      // FIXME: slider delay when this.zoom.value changed programaticaly
      this.activePyramid.pyramid.zoom = scale;
    }

    this.renderer.onSelectItem = (item) => {
      this.$timeout(() => {
        this.activePyramid.pyramid.number = item.children ? item.children.length : 0;
        this.renderer.tree.selectedNode.data.deductive = item.data.deductive;
      });
    }

    // this.updateData = false;

  }

  closeTab(event, key) {
    event.preventDefault();

    if (Object.keys(this.pyramidBuilderService.store).length === 1) {
      this.toggle();
      return;
    }

    this.pyramidBuilderService.deletePyramid(key);
  }

  toggleTreeQ() {
    this.activePyramid.pyramid.question.active = !this.activePyramid.pyramid.question.active;
    this.renderer.tree.toggleQuestions(this.activePyramid.pyramid.question.active);
  }

  setDeductive() {
    this.renderer.tree.changeDeductive();
  }

  onBoxesNumberChange() {
    this.renderer.tree.changeChildsNodeCount(this.renderer.tree.selectedNode, this.activePyramid.pyramid.number);
  }

  setActiviPyramid(activePyramidKey) {
    this.$timeout(() => {
      if (!this.renderer) return;

      Object.keys(this.pyramidBuilderService.store).forEach((key) => {
        if (key !== 'opacity' && key !== 'scale') {
          this.pyramidBuilderService.store[key].pyramid.active = key == activePyramidKey;
        }
      });



      this.activePyramid = this.pyramidBuilderService.store[activePyramidKey]; 
      // if (!this.activePyramid) {

      //   return;
      // }

      this.renderer.questionFlag = this.activePyramid.pyramid.question.active;
      this.renderer.zoom = this.activePyramid.pyramid.zoom;

      this.renderer.scheme = this.activePyramid.pyramid.scheme;
      setTimeout(() => {
        this.renderer.render();
      });
    });
  }

  savePyramid() {
    this.pyramidBuilderService.save(this.opacity.value);
  }

}

export default PyramidBuilderController;



// WEBPACK FOOTER //
// ./client/app/components/pyramid-builder/pyramid-builder.controller.js